import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

export type GetAccessorialsHistoryFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

export function getAccessorialsHistoryFactory({
  spotQuoteRepository,
}: GetAccessorialsHistoryFactoryDependencies) {
  return async function getAccessorialsHistoryImpl(
    carrierId: number,
    config?: { signal?: AbortSignal }
  ) {
    return await spotQuoteRepository.getAccessorialsHistoryByCarrier(carrierId, config)
  }
}

export function getAccessorialsHistory(carrierId: number, config?: { signal?: AbortSignal }) {
  const httpClient = new ShipperGuideClient()
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const newAccessorialsHistory = getAccessorialsHistoryFactory({ spotQuoteRepository })

  return newAccessorialsHistory(carrierId, config)
}
